/**
 * Treatments API
 * API calls for patient treatments
 */

import { apiClient } from './config';

/**
 * Fetch current date treatments for a patient
 * @param {string} customerId - Patient Customer ID
 * @param {string} date - Date in YYYY-MM-DD format
 * @returns {Promise} Treatments data
 */
export const fetchCurrentDateTreatment = async (customerId, date) => {
  const response = await apiClient.get(`/api/patient/${customerId}/current-date-treatment/${date}`);
  return response.data;
};
